import getGlobal from '../getGlobal';
var g = getGlobal();
export default g.requestAnimationFrame || g.webkitRequestAnimationFrame || g.mozRequestAnimationFrame || g.oRequestAnimationFrame || g.msRequestAnimationFrame;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/animation/nativeRequestAnimationFrame.js
// module id = 1301
// module chunks = 31